import Marker from "../../booking_editor/models/gmap/marker";
import Map from "../../booking_editor/models/gmap/map";
import SpotController from "../../spot_map/controllers/spot_controller";
import { drawPolygon } from "../../google_maps/polygon";

export default class MapController {
  constructor(element, props) {
    const { lat, lng, zoom, mapType, mapFilterColor, mapFilterOpacity } = props;
    this.assets = props.assets

    this.spots = Object.values(props.spots || {});
    this.piers = Object.values(props.piers || {});

    this.map = new Map({ element, lat, lng, zoom, mapType, mapFilterColor, mapFilterOpacity });
    this.markers = [];

    this.spotController = new SpotController(this.map, {dispatch: props.dispatch, markers: this.markers});
    this.drawSpots();
    this.drawPiers(this.map.gMap);
  }

  updateSpots(spots) {
    this.spots = Object.values(spots || {});
    this.removeAllMarkers();
    this.drawSpots();
  }

  drawSpots() {
    this.spots.forEach(spot => {
      const marker = new Marker(spot, this.assets);
      this.markers.push(marker);
      this.spotController.draw(spot, marker);
    });
  }

  drawPiers(map) {
    this.piers.forEach(pier => drawPolygon({ map, points: pier.points }))
  }

  removeAllMarkers() {
    this.markers.forEach(marker => marker.draw(null));
    this.markers = [];
  }
}
